import { scriptHideProperty } from '@ps/utils/config'
import AnimationCurve from '@ps/views/workbench/animation/animation-curve.vue'
import QcPoint from '@ps/views/workbench/animation/form-components/qc-point'
import AnimationColor from '@ps/views/workbench/animation/form-components/animation-color.vue'
import { getScriptList } from '@ps/api/editor/script'
import _ from 'lodash'
import { Event, EventBus } from '@ps/utils/event-bus'
import i18n from '@ps/lang'
import { resetToBeginningAfterPlay } from '@ps/bridge/qc/node'
import AddTweenPosition from '@ps/views/workbench/animation/form-components/add-tween-position.vue'
import { getAnimationName } from '@ps/workbench/animation'

const scriptManager = {
  namespaced: true,

  state: {
    scriptList: null,
  },

  mutations: {
    updateScriptList(state, { scriptList }) {
      state.scriptList = scriptList
    },
  },

  actions: {
    getScriptParms({ state, rootState }, node) {
      return new Promise((resolve, reject) => {
        // debugger
        const formItemList = {}
        const formValue = {}
        const Serializer = rootState.workspace.game.data.Serializer
        const curNode = node || rootState.workspace.game.activeNode
        curNode.scripts.forEach((item) => {
          // addType===1表示原生添加的 BuiltIn script
          if (item.addType === 1) {
            calForm(item)
          }
        })

        function calForm(script) {
          const meta = script.getMeta()
          if (typeof formItemList[script.uuid] === 'undefined') {
            formItemList[script.uuid] = []
          }
          if (typeof formValue[script.uuid] === 'undefined') {
            formValue[script.uuid] = {}
            formValue[script.uuid]['psScript'] = script
          }
          for (const i in meta) {
            if (i === 'enable' || i === 'runInEditor') {
              // eslint-disable-next-line no-continue
              continue
            }
            formValue[script.uuid][i] = script[i]
            if (typeof script.animationName !== 'undefined') {
              formValue[script.uuid]['animationName'] = getAnimationName(
                script.animationName,
              )
              formValue[script.uuid]['animationClassName'] = script.class
            }
            // 有些属性不用显示
            if (scriptHideProperty.indexOf(i) > -1) {
              // eslint-disable-next-line no-continue
              continue
            }
            // 预设动画
            // if (script.builtinId && i !== 'to' && i !== 'from') {
            //   // eslint-disable-next-line no-continue
            //   continue
            // }
            // eslint-disable-next-line no-continue
            if (script.class === 'qc.TweenPosition' && i === 'to') continue
            if (script.class === 'qc.TweenPosition' && i === 'from') {
              formItemList[script.uuid].push({
                prop: 'offsetX',
                type: 'input',
                subtype: 'number',
                label: 'offset-x',
                title: i,
                params: {
                  size: 'mini',
                  script: script,
                  controls: false,
                },
                class: script.class,
              })
              formItemList[script.uuid].push({
                prop: 'offsetY',
                type: 'input',
                subtype: 'number',
                label: 'offset-y',
                title: i,
                params: {
                  size: 'mini',
                  script: script,
                  controls: false,
                },
                class: script.class,
              })
              formItemList[script.uuid].push({
                prop: 'tweenPositionArea',
                component: AddTweenPosition,
                params: {
                  size: 'mini',
                  script: script,
                  controls: false,
                },
                field: {
                  listeners: {
                    click: () => {
                      console.log('hello world')
                    },
                  },
                },
                class: script.class,
              })
              // eslint-disable-next-line no-continue
              continue
            }
            if (i === 'style') {
              formItemList[script.uuid].push({
                prop: i,
                type: 'select',
                label: i,
                title: i,
                class: '',
                params: {
                  size: 'mini',
                  script: script,
                  options: [
                    {
                      label: i18n.t('workbench.animation.circular.once'),
                      value: 0,
                    },
                    {
                      label: i18n.t('workbench.animation.circular.loop'),
                      value: 1,
                    },
                    {
                      label: i18n.t('workbench.animation.circular.pingPong'),
                      value: 2,
                    },
                  ],
                },
              })
              // eslint-disable-next-line no-continue
              continue
            }
            // eslint-disable-next-line default-case
            switch (meta[i]) {
              case Serializer.INT:
              case Serializer.INTS:
              case Serializer.NUMBER:
              case Serializer.NUMBERS:
                formItemList[script.uuid].push({
                  prop: i,
                  type: 'input',
                  subtype: 'number',
                  label: i,
                  title: i,
                  params: {
                    size: 'mini',
                    script: script,
                    controls: false,
                  },
                  class: script.class,
                })
                break
              case Serializer.BOOLEAN:
              case Serializer.BOOLEANS:
                formItemList[script.uuid].push({
                  prop: i,
                  type: 'switch',
                  label: i,
                  title: i,
                  params: {
                    size: 'mini',
                    script: script,
                  },
                  class: script.class,
                })
                break
              case Serializer.STRING:
              case Serializer.STRINGS:
                formItemList[script.uuid].push({
                  prop: i,
                  type: 'input',
                  subtype: 'text',
                  label: i,
                  title: i,
                  params: {
                    size: 'mini',
                    script: script,
                  },
                  class: script.class,
                })
                break
              case Serializer.MAPPING:
                break
              case Serializer.COLOR:
              case Serializer.COLORS:
                formItemList[script.uuid].push({
                  type: 'component',
                  component: AnimationColor,
                  prop: i,
                  script: script,
                  class: script.class,
                })
                break
              case Serializer.POINT:
              case Serializer.POINTS:
                formItemList[script.uuid].push({
                  type: 'component',
                  component: QcPoint,
                  prop: i,
                  script: script,
                  class: script.class,
                })
                break
              case Serializer.RECTANGLE:
                break
              case Serializer.RECTANGLES:
                break
              case Serializer.CIRCLE:
                break
              case Serializer.FONT:
                break
              case Serializer.FONTS:
                break
              case Serializer.CIRCLES:
                break
              case Serializer.ELLIPSE:
                break
              case Serializer.ELLIPSES:
                break
              case Serializer.GEOM:
              case Serializer.GEOMS:
                formItemList[script.uuid].push({
                  type: 'component',
                  component: AnimationCurve,
                  label: i18n.t(
                    'workbench.animation.scriptManager.animationCurve',
                  ),
                  class: 'curve-container',
                })
                break
              case Serializer.NODE:
                break
              case Serializer.NODES:
                break
              case Serializer.TEXTURE:
                break
              case Serializer.TEXTURES:
                break
              case Serializer.PREFAB:
                break
              case Serializer.PREFABS:
                break
              case Serializer.ACTION:
                break
              case Serializer.ACTIONMANAGER:
                break
              case Serializer.ANIMATOR:
                break
              case Serializer.ANIMATORS:
                break
              case Serializer.AUDIO:
                break
              case Serializer.AUDIOS:
                break
              case Serializer.TEXTASSET:
                break
              case Serializer.TEXTASSETS:
                break
              case Serializer.EXCELASSET:
                break
              case Serializer.EXCELASSETS:
                break
            }
          }
        }

        resolve({ formItemList, formValue })
      })
    },

    getScriptList({ commit }) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        const list = _.get(await getScriptList(), 'data.list')
        commit('updateScriptList', { scriptList: list })
        resolve()
      })
    },

    // 播放当前节点的动画
    playAnimation({ rootState }, node) {
      return new Promise((resolve, reject) => {
        try {
          node.scripts.forEach((item) => {
            if (item.addType === 1) {
              item.playForward(true)
            }
          })
          EventBus.$emit(Event.CLEAR_RESIZE_HIGHLIGHT)
          resolve()
        } catch (e) {
          reject(e.message)
        }
      })
    },

    scenePlayAnimation({ rootState }, node) {
      return new Promise((resolve, reject) => {
        try {
          node.scripts.forEach((item) => {
            if (item.addType === 1 && item.playOnAwake) {
              item.playForward(true)
            }
          })
          const animations = node.scripts.map((item) => {
            if (item.addType === 1 && item.playOnAwake) {
              return { delay: item.delay, duration: item.duration }
            }
            return { delay: 0, duration: 0 }
          })
          resetToBeginningAfterPlay(animations, node)
          EventBus.$emit(Event.CLEAR_RESIZE_HIGHLIGHT)
          resolve()
        } catch (e) {
          reject(e.message)
        }
      })
    },
  },
}

export default scriptManager
